import { ResponseError } from "./errors/responseError"
import { isDateString } from "./isDateString"

const dateReviver = (_key: string, value: unknown): unknown => {
  if (!isDateString(value)) {
    return value
  }

  return new Date(value)
}

export const parseJSON = (
  text: string,
  { response }: { response: Response },
): unknown => {
  if (text === "") {
    throw new ResponseError({
      error: response.statusText,
      statusCode: response.status,
      message: `${response.status}: Empty response body`,
      title: "Empty response body",
      detail: "The server returned no content where a JSON body was expected.",
      traceId: "",
      url: response.url,
      type: "parseJsonError",
    })
  }

  return JSON.parse(text, dateReviver)
}
